// tokenReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	updateReduxData: false,
};

const updateReduxData = createSlice({
	name: 'updateData', // Use the same name as in your store configuration
	initialState,
	reducers: {
		setUpdateReduxData: (state, action) => {
			state.updateReduxData = action.payload;
		},
	},
});

export const { setUpdateReduxData } = updateReduxData.actions;
export default updateReduxData.reducer;
